import { getParentPath } from './utils';
import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { DAMO_AUTH_PATHS } from '../../auth-paths';
import { AuthService } from '../services/auth.service';

export const unauthenticatedGuard: CanActivateFn = async (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const isUserAuthenticated = await authService.isUserAuthenticated();
  if(!isUserAuthenticated) {
    return true;
  }

  const { SAMLRequest, RelayState } = route.queryParams;
  const queryParams = SAMLRequest
      ? { SAMLRequest, ...(RelayState ? { RelayState } : {}) }
      : undefined;

  return router.createUrlTree([`${getParentPath(route)}/${DAMO_AUTH_PATHS.REDIRECT}`], { queryParams });
};